// extracted by mini-css-extract-plugin
module.exports = {"card":"MetaCard_card__25d69","compareStyle":"MetaCard_compareStyle__1nQ6_"};